import React from 'react'
import Skeleton from 'react-loading-skeleton'
import SectionBlock from 'components/SectionBlock'
import ProductImageGallerySkeleton from './ProductImageGallerySkeleton'
import ProductDetailsLeftSideSkeleton from './ProductDetailsLeftSideSkeleton'
import ProductPurchaseActionsSkeleton from './ProductPurchaseActionsSkeleton'
import ProductDetailsTabSkeleton from './ProductDetailsTabSkeleton'

const ProductDetailPageSkeleton = () => {
  return (
    <>
      {/* Main product info section */}
      <div className="px-3 md:px-0 grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-14 mb-10 mt-4">
        <ProductImageGallerySkeleton />

        <div className="flex flex-col gap-10 md:flex-row md:gap-20">
          <ProductDetailsLeftSideSkeleton />

          <div className="flex-1">
            <ProductPurchaseActionsSkeleton />
          </div>
        </div>
      </div>

      {/* Banner section skeleton */}
      <div className="-mx-3 md:mx-0 mt-20 mb-10">
        <Skeleton
          height={200}
          baseColor="#f8fafc"
          highlightColor="#e2e8f0"
          className="!rounded-lg"
        />
      </div>

      {/* Similar products section skeleton */}
      <div className="mt-16 pb-2.5 mx-3 md:mx-0">
        <SectionBlock
          title="მსგავსი პროდუქტები"
          withPaddingBottom
          titleComponent="h1"
        >
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
            {Array(5)
              .fill()
              .map((_, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-4 border border-[#ededed] transition-all duration-300 hover:border-gray-300 hover:shadow-sm"
                >
                  <Skeleton
                    height={120}
                    baseColor="#f8fafc"
                    highlightColor="#e2e8f0"
                    className="!rounded-lg mb-3"
                  />
                  <Skeleton
                    height={16}
                    width="90%"
                    baseColor="#f1f5f9"
                    highlightColor="#e2e8f0"
                    className="mb-2 !rounded-sm"
                  />
                  <Skeleton
                    height={16}
                    width="70%"
                    baseColor="#f1f5f9"
                    highlightColor="#e2e8f0"
                    className="mb-3 !rounded-sm"
                  />
                  <Skeleton
                    height={20}
                    width="60%"
                    baseColor="#f1f5f9"
                    highlightColor="#e2e8f0"
                    className="!rounded-sm"
                  />
                </div>
              ))}
          </div>
        </SectionBlock>
      </div>

      {/* TAB */}
      <ProductDetailsTabSkeleton />

      {/* FAQ section skeleton */}
      <div className="bg-white rounded-2xl mt-5 mb-10 shadow-sm border border-[#ededed] px-5 md:px-10 py-2 md:py-5 mx-3 md:mx-0">
        <div className="space-y-4">
          {Array(3)
            .fill()
            .map((_, index) => (
              <div key={index} className="border-b border-[#ededed] pb-4">
                <Skeleton
                  height={20}
                  width="80%"
                  baseColor="#f1f5f9"
                  highlightColor="#e2e8f0"
                  className="mb-3 !rounded-sm"
                />
                <Skeleton
                  count={2}
                  height={14}
                  baseColor="#f8fafc"
                  highlightColor="#e2e8f0"
                  className="!rounded-sm"
                />
              </div>
            ))}
        </div>
      </div>
    </>
  )
}

export default ProductDetailPageSkeleton
